import { createSelector } from "reselect"

const browserState = (state) => state.browser

export const browserIsMobile = createSelector(
  browserState,
  (browser) => browser.lessThan.mobile
)
